import { Component, OnInit, ViewEncapsulation, ElementRef, Inject, Renderer2 } from '@angular/core';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'suitability-panel',
    templateUrl: './suitability-panel.component.html',
    styleUrls: ['./suitability-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class SuitabilityPanelComponent extends DialogPanelComponentContent implements OnInit {
    public showMessage: boolean = true;
    constructor(
        public dialogReference: MatDialogRef<SuitabilityPanelComponent>,
        element: ElementRef,
        private store: Store<AppState>,
        private renderer: Renderer2,
        @Inject(MAT_DIALOG_DATA) public data,

    ) {
        super(element, true);
    }
    public ngOnInit() {
        super.ngOnInit();
    }
    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
    
    public navigateTo(path: string, element: string, blank: boolean = false) {
        this.sendTracking('Element Clicked', {
          'Product Area Origin': 'Detalhe perfil investidor',
          'Time Responsável': 'Brooklyn Dumbo',
          Element: element
        });
        if(blank) {
            window.open(path, '_blank');
        }
        window.location.href = path;
      };

      public closeMenu() {
        super.close(this.dialogReference, null);
        this.renderer.removeClass(document.body, 'overflow--hidden');
    }


}
